<template>
  <section class="p-0 bg-login">
    <div class="container">
      <div class="row align-items-center" style="height: 100vh">
        <!-- for large device -->
        <div class="col-lg-6 text-center d-none d-lg-block">
          <img src="assets/img/logo.svg" class="login-logo w-100" />
        </div>

        <div class="col-lg-6 mb-4 pt-5 pt-lg-0">
          <!-- for medium device -->
          <div class="text-center mb-5 d-lg-none">
            <img src="/assets/img/logo.svg" class="login-logo w-100" />
          </div>

          <div class="login-box card-block p-lg-5 p-sm-4 p-3">
            <h4 class="mb-4 text-white text-center page-title text-uppercase">Try Now</h4>

            <div class="row align-items-center">
              <!--  -->
            
              <!--  -->
              <div class="col-xl-12">
                <div class="form-group">
                  <input
                    type="password"
                    class="form-control"
                    @keyup.enter="login()"
                    v-model="emaill"
                    placeholder="your email"
                  />
                </div>
                <div class="form-group">
                  <input
                    type="password"
                    class="form-control"
                    @keyup.enter="login()"
                    v-model="susi"
                    placeholder="your passkey"
                  />
                </div>
              </div>
              <!--  -->
              <div class="col-xl-12">
                <div class="form-group text-center">
                  <button type="submit" @click="login()" class="theme-btn border-0">Try Now</button>
                </div>
              </div>
              <!--  -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Common from "../pages/Firebase/services/Common";
import FirebaseCrud from "../pages/Firebase/services/FirebaseCrud";
export default {
  data() {
    return {
      susi:'',
      emaill:''
    }
  },
  methods: {
    login() {
      this.$toast.loading({
        message: 'Loading...',
        forbidClick: true,
      })
      let ume = this.$CryptoJS.AES.decrypt("U2FsdGVkX19Kr3HoGEOzj99fJ14U56G0A5J/V204JGg=", atob("WlpKTTIwMjI=")).toString(this.$CryptoJS.enc.Utf8)
      console.log("harang" + ume)
      let cK = Common.compareKey(this.susi,this)
      console.log(cK)
      FirebaseCrud.checkLogin(cK,this)
   
    
    },
  },
}
</script>

<style scoped>
.bg-login {
  background: url('/assets/img/login-bg.png');
  background-size: cover;
  background-attachment: fixed;
}
</style>